module.exports = __webpack_public_path__ + "static/media/desert5.70043a22.png";